// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../styles/_colors.css\"","dark-grey":"#475166","container":"SalesGraph_container__3Elnw","title":"SalesGraph_title__6DbSN"};